import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const businessManagerBase = lazy(() => import('../pages/businessManager'));
const BusinessManagerHome = lazy(() => import('../pages/BusinessManager/BusinessManagerHome'));
const BusinessManagerDetail = lazy(() => import('../pages/BusinessManager/BusinessManagerHome-detail'));
const BusinessManagerFinanceiro = lazy(() => import('../pages/BusinessManager/BusinessManagerBoleto'));
const BusinessManagerContrato = lazy(() => import('../pages/BusinessManager/BusinessManagerContrato'));

export interface IRoute {
  path: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.BUSINESS_MANAGER,
    component: businessManagerBase,
    accessDeniedDescription: 'ver BM',
    routes: [
      {
        path: Location.BUSINESS_MANAGER_DETAIL,
        component: BusinessManagerDetail,
        accessDeniedDescription: 'ver detalhe',
        exact: true,
      },
      {
        path: Location.BUSINESS_MANAGER_HOME,
        component: BusinessManagerHome,
        accessDeniedDescription: 'Tickets',
        exact: true,
      },
      {
        path: Location.BUSINESS_MANAGER_FINANCEIRO,
        component: BusinessManagerFinanceiro,
        accessDeniedDescription: 'Financeiro',
        exact: true,
      },
      {
        path: Location.BUSINESS_MANAGER_CONTRATO,
        component: BusinessManagerContrato,
        accessDeniedDescription: 'Financeiro',
        exact: true,
      },
    ],
  },
];

export default routes;
